var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"container-fliud"},[_c('div',{staticClass:"header_bg text-center",style:({ backgroundImage: 'url(' + _vm.aboutUsCommon.Banner + ')' })})])}
var staticRenderFns = []

export { render, staticRenderFns }